import { Outlet, Route, Routes } from 'react-router'
import { Link } from 'react-router-dom'
import { Tab } from '../components/tab'

export function Root() {
	return (
		<>
			<Routes>
				<Route path="/" element={<Main />} />
				<Route path="/:id/*" element={<Detail />} />
			</Routes>
			<div className="grow">
				<Outlet />
			</div>
		</>
	)
}

function Main() {
	return (
		<div className="flex items-center gap-4 mb-5">
			<h2 className="text-lg font-semibold">Adresář</h2>
		</div>
	)
}

function Detail() {
	return (
		<>
			<div className="flex items-center gap-4 mb-5">
				<Link to="../" className="text-gray-500 hover:text-gray-700">
					← Zpět
				</Link>
				<h2 className="text-lg font-semibold">Detail zákazníka</h2>
			</div>

			<div className="flex gap-4 p-4 justify-between items-start mb-4">
				<nav className="border-b border-gray-200 flex-1">
					<ul className="flex -mb-px">
						<li>
							<Tab to="." end>
								Základní
							</Tab>
						</li>
						<li>
							<Tab to="address">Adresy</Tab>
						</li>
						<li>
							<Tab to="reservation">Rezervace</Tab>
						</li>
					</ul>
				</nav>
				<div className="flex-1">
					<Outlet />
				</div>
			</div>
		</>
	)
}
